const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { INVITATION_LINK_TAB, NEW_INVITATION_LINK_TAB_PATHS } from "@/react/components/SettingsApp/InvitationLinks/InvitationLinkViewModal/constants";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/invitation_links/new/")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      to: NEW_INVITATION_LINK_TAB_PATHS[INVITATION_LINK_TAB.DETAILS],
      replace: true,
      search: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});